module.exports = {
  footerText: 'Copyright Dart Pos © 2021',
}
